import { html, LitElement, unsafeCSS } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import _L from "../../../utils/Labels";
import { EAvatarVariant } from "../Avatar/Avatar";
import styles from './ChatImage.scss?inline';

@customElement('app-chat-image')
export class ChatImage extends LitElement {
    static styles = [unsafeCSS(styles)];

    @property({ attribute: false, type: String }) k_src: string | null = null;
    @property({ attribute: false, type: Boolean }) isRetryMode: boolean;
    @query('.image-loading') private loading!: HTMLDivElement;
    @query('.image-retry') private retryOpt!: HTMLDivElement;

    render() {
        const source = !this.isRetryMode ? this.k_src : null;

        return html`
            <div class='wrapper'>
                <div class='image-loading'>${_L("general.loading...")}</div>
                <div
                    class='image-retry hide'
                    @click=${this.RetryResolveUrl}
                >
                    ${_L("general.retry")}
                </div>
                <app-avatar
                    class='avatar image-message'
                    .k_useCache=${true}
                    .k_variant=${EAvatarVariant.SQUARE}
                    .k_src=${source}
                    @k-avatar-resolve-src-err=${this.EvalAvatarResolveUrl}
                >
                </app-avatar>
            </div>
        `
    }

    private EvalAvatarResolveUrl() {
        this.loading.classList.add("hide");
        this.retryOpt.classList.remove("hide");
        this.isRetryMode = true;
    }

    private RetryResolveUrl(ev: Event) {
        ev.stopPropagation();
        ev.preventDefault();
        this.retryOpt.classList.add("hide");
        this.loading.classList.remove("hide");
        this.isRetryMode = false;
    }
}